module.exports = __webpack_public_path__ + "532c154edb7e3ad48282f6e15c7d9338.pdf";